import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import { ScrollingColumns } from 'foundations-components/transitional/components/ScrollingColumns';
import { Text } from 'foundations-components/components/Text';
import { Tile } from 'foundations-components/transitional/components/Tile';
import { jsx as _jsx } from "react/jsx-runtime";
const AICompanion = () => {
  return /*#__PURE__*/_jsx(Tile, {
    children: /*#__PURE__*/_jsx(ScrollingColumns, {
      leftColumnContent: /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        gap: "600",
        padding: "600",
        children: /*#__PURE__*/_jsx(SelectableButton, {
          children: /*#__PURE__*/_jsx("b", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.interactiveEducation.quizMe"
            })
          })
        })
      }),
      leftColumnHeader: /*#__PURE__*/_jsx(Text, {
        as: "h3",
        padding: "600",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.interactiveEducation.aiCompanion"
        })
      }),
      leftColumnMinWidth: "25%",
      rightColumnContent: /*#__PURE__*/_jsx("p", {
        children: "Right content"
      }),
      rightColumnFooter: /*#__PURE__*/_jsx("p", {
        children: "Right footer"
      }),
      rightColumnHeader: /*#__PURE__*/_jsx("p", {
        children: "Right header"
      }),
      rightColumnWidth: "75%"
    })
  });
};
export default AICompanion;